import React from 'react';
import withInit from 'WithInit';
import EditPDFLandingPageWrapper from './EditPDFLandingPageWrapper';

const EditPDFLandingPage = () => <EditPDFLandingPageWrapper layout="freeWriteBackground" />;

export default withInit(EditPDFLandingPage);



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/index.jsx